import { render, staticRenderFns } from "./Criterio.vue?vue&type=template&id=5f3298b1&scoped=true"
import script from "./Criterio.vue?vue&type=script&lang=js"
export * from "./Criterio.vue?vue&type=script&lang=js"
import style0 from "./Criterio.vue?vue&type=style&index=0&id=5f3298b1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3298b1",
  null
  
)

export default component.exports